import { Controller } from "@hotwired/stimulus"

// Simple collapsible section controller
// Usage: data-controller="collapsible"
//        data-collapsible-open-value="true/false" (default state)
//        data-action="click->collapsible#toggle" on header
//        data-collapsible-target="content" on collapsible content
//        data-collapsible-target="icon" on chevron icon (optional)
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: true } }

  connect() {
    // Set initial state without animation
    if (!this.openValue) {
      this.contentTarget.classList.add('hidden')
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = 'rotate(0deg)'
      }
    } else {
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = 'rotate(180deg)'
      }
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.contentTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    // Remove hidden first to measure height
    this.contentTarget.classList.remove('hidden')

    // Set initial state - collapsed
    this.contentTarget.style.height = '0px'
    this.contentTarget.style.overflow = 'hidden'
    this.contentTarget.style.transition = 'height 0.3s ease-out'

    // Get the natural height
    const naturalHeight = this.contentTarget.scrollHeight + 'px'

    // Animate to natural height
    requestAnimationFrame(() => {
      this.contentTarget.style.height = naturalHeight
    })

    // Clean up after animation
    setTimeout(() => {
      this.contentTarget.style.height = 'auto'
      this.contentTarget.style.overflow = 'visible'
    }, 300)

    // Rotate chevron
    if (this.hasIconTarget) {
      this.iconTarget.style.transition = 'transform 0.3s ease-out'
      this.iconTarget.style.transform = 'rotate(180deg)'
    }

    this.openValue = true
  }

  close() {
    // Set current height explicitly first
    const currentHeight = this.contentTarget.scrollHeight + 'px'
    this.contentTarget.style.height = currentHeight
    this.contentTarget.style.overflow = 'hidden'
    this.contentTarget.style.transition = 'height 0.3s ease-out'

    // Force reflow
    this.contentTarget.offsetHeight

    // Animate to 0 height
    requestAnimationFrame(() => {
      this.contentTarget.style.height = '0px'
    })

    // Hide after animation
    setTimeout(() => {
      this.contentTarget.classList.add('hidden')
      this.contentTarget.style.height = ''
      this.contentTarget.style.overflow = ''
      this.contentTarget.style.transition = ''
    }, 300)

    // Reset chevron
    if (this.hasIconTarget) {
      this.iconTarget.style.transition = 'transform 0.3s ease-out'
      this.iconTarget.style.transform = 'rotate(0deg)'
    }

    this.openValue = false
  }
}
